import type { ClientAttachmentId, ClientItemId } from "owa-client-ids";
import type AttachmentType from "owa-service/lib/contract/AttachmentType";
import { action } from "satcheljs";

// IMPORTANT: Do not add any other code here. This is only to define the action. Any orchestrator should be in a different place.

/**
 * Action called whenever an attachment is created
 * @param parentItemId The id of the parent item to which the attachment is attached
 * @param attachmentId The id of the created attachment
 * @param attachment The attachment that was created
 * @param shouldTriggerAddInAttachmentsChangedCallback If we should trigger attachment event changed or not
 */
export interface ON_ATTACHMENT_CREATEDActionMessage {
    parentItemId: ClientItemId;
    attachmentId: ClientAttachmentId;
    attachment: AttachmentType;
    targetWindow: Window;
    shouldTriggerAddInAttachmentsChangedCallback: boolean;
}
const defaultExport: (parentItemId: ClientItemId, attachmentId: ClientAttachmentId, attachment: AttachmentType, targetWindow: Window, shouldTriggerAddInAttachmentsChangedCallback?: boolean) => ON_ATTACHMENT_CREATEDActionMessage = action("ON_ATTACHMENT_CREATED", (parentItemId: ClientItemId, attachmentId: ClientAttachmentId, attachment: AttachmentType, targetWindow: Window, shouldTriggerAddInAttachmentsChangedCallback: boolean = true): ON_ATTACHMENT_CREATEDActionMessage => {
    return {
        parentItemId,
        attachmentId,
        attachment,
        targetWindow,
        shouldTriggerAddInAttachmentsChangedCallback,
    };
});
export default defaultExport;
